import $ from 'jquery';
import AOS from 'aos';
import Rellax from 'rellax';
import 'jquery-parallax.js';
import 'venobox';

$(document).ready(function () {
    AOS.init();

    if ($('.rellax').length) {
        // eslint-disable-next-line no-new
        new Rellax('.rellax', {
            center: true,
            round: true,
            vertical: true,
            horizontal: false,
        });
    }

    // Enable mobile touch effects;
    document.addEventListener('touchstart', function () {}, true);

    $('.company-contact-venobox').venobox({
        spinner: '',
        closeColor: '#fff',
        closeBackground: 'transparent',
        framewidth: '940px',
        bgcolor: 'transparent',
    });

    function initLoginVenobox() {
        $('.login-popup-venobox').venobox({
            spinner: '',
            closeColor: '#fff',
            closeBackground: 'transparent',
            bgcolor: 'transparent',
            framewidth: '650px',
        });
    }

    initLoginVenobox();


    /* Open all truly external links in new tab */
    $('a[href^="http://"], a[href^="https://"]').on('click', function () {
        const currentHostname = window.location.hostname;
        const destHostname = this.hostname;
        if (currentHostname !== destHostname) {
            $(this).attr('target', '_blank');
        }
    });

    $.fn.slideFadeToggle = function (speed, easing, callback) {
        return this.animate({ opacity: 'toggle', height: 'toggle' }, speed, easing, callback);
    };

    /* Mobile Nav */
    const $mobileMenuTrigger = $('.nav-mobile__menu-trigger-wrapper');
    const $mobileMenuContainer = $('.nav-mobile__menu-container');
    const $mobileAccountTrigger = $('.nav-mobile__account-trigger-wrapper');
    const $mobileAccountContainer = $('.nav-mobile__account-container');

    $mobileMenuTrigger.click(function () {
        if ($(this).hasClass('nav-mobile__menu-trigger-wrapper--active')) {
            $(this).removeClass('nav-mobile__menu-trigger-wrapper--active');
            $mobileMenuContainer.removeClass('nav-mobile__menu-container--active');
        } else {
            $(this).addClass('nav-mobile__menu-trigger-wrapper--active');
            $mobileMenuContainer.addClass('nav-mobile__menu-container--active');
            if ($mobileAccountTrigger.hasClass('nav-mobile__account-trigger-wrapper--active')) {
                $mobileAccountTrigger.removeClass('nav-mobile__account-trigger-wrapper--active');
                $mobileAccountContainer.removeClass('nav-mobile__account-container--active');
            }
        }
    });
    $mobileAccountTrigger.click(function () {
        if ($(this).hasClass('nav-mobile__account-trigger-wrapper--active')) {
            $(this).removeClass('nav-mobile__account-trigger-wrapper--active');
            $mobileAccountContainer.removeClass('nav-mobile__account-container--active');
        } else {
            $(this).addClass('nav-mobile__account-trigger-wrapper--active');
            $mobileAccountContainer.addClass('nav-mobile__account-container--active');
            if ($mobileMenuTrigger.hasClass('nav-mobile__menu-trigger-wrapper--active')) {
                $mobileMenuTrigger.removeClass('nav-mobile__menu-trigger-wrapper--active');
                $mobileMenuContainer.removeClass('nav-mobile__menu-container--active');
            }
        }
    });

    // Desktop Nav
    const navHeight = $('.nav-desktop').height();
    // eslint-disable-next-line arrow-body-style
    const tallestNavHeight = $('.nav-desktop__item-child-links-wrapper').toArray().reduce((tallest, element) => {
        return $(element).height() > tallest ? $(element).height() : tallest;
    }, 0);

    $('.nav-desktop__item.js-has-children').hover(
        function () {
            $('.nav-desktop').css('height', tallestNavHeight + navHeight);
        }, function () {
            $('.nav-desktop').css('height', '');
        },
    );

    if ($('main section').last().hasClass('content-section--alt')) {
        $('.footer').css('padding-top', '25px');
    }

    /* Directory Filters */
    const $dirMobileFilters = $('.directory-mobile-filters');
    $('.directory-mobile-filter-area__trigger').click(function () {
        if ($dirMobileFilters.hasClass('directory-mobile-filters--active')) {
            $dirMobileFilters.removeClass('directory-mobile-filters--active');
            // $dirMobileFilters.slideFadeToggle(100);
        } else {
            $dirMobileFilters.addClass('directory-mobile-filters--active');
            // $dirMobileFilters.slideFadeToggle(100);
        }
    });

    $('.js-directory-mobile-filters-back').click(function () {
        if ($dirMobileFilters.hasClass('directory-mobile-filters--active')) {
            // $dirMobileFilters.slideFadeToggle(100);
            $dirMobileFilters.removeClass('directory-mobile-filters--active');
        }
    });

    $('.filter-group__label').not('.filter-group__label--back').click(function () {
        if ($(this).hasClass('active')) {
            $(this).removeClass('active');
            $(this).parent().find('.filter-group__options-container').slideFadeToggle(100);
            $(this).attr('aria-expanded', 'false');
        } else {
            $(this).addClass('active');
            $(this).parent().find('.filter-group__options-container').slideFadeToggle(100);
            $(this).attr('aria-expanded', 'true');
        }
    });

    function updateQueryStringParameter(uri, key, value) {
        const re = new RegExp(`([?&])${key}=.*?(&|$)`, 'i');
        // Determine of param will be the first param in the uri
        const separator = uri.indexOf('?') !== -1 ? '&' : '?';
        // Test if key in uri
        if (uri.match(re)) {
            // Replace values inbetween the two sets of params "()"" in regex expression
            return uri.replace(re, `$1${key}=${value}$2`);
        }
        return `${uri}${separator}${key}=${value}`;
    }

    $('.js-filter-option').click(function (e) {
        e.preventDefault();
        const hrefAttr = $(this).attr('href');
        const params = hrefAttr.split('&');
        let locationUrl = window.location.href;
        for (let index = 0; index < params.length; index += 1) {
            const element = params[index];
            const keyValuePair = element.split('=');
            locationUrl = updateQueryStringParameter(locationUrl, keyValuePair[0], keyValuePair[1]);
        }
        window.location.href = locationUrl;
    });

    $('.js-multi-level-categories .filter-group__label--back').click(function (e) {
        e.preventDefault();
        const locationUrl = updateQueryStringParameter(window.location.href, 'category', '');
        window.location.href = locationUrl;
    });

    $('.js-directory-search-form').submit(function (e) {
        e.preventDefault();
        const searchQuery = $(this).find('input.directory-sidebar__search-input').val();
        const locationUrl = updateQueryStringParameter(window.location.href, 'q', searchQuery);
        window.location.href = locationUrl;
    });

    $('.js-paginate-load-more').click(function (e) {
        e.preventDefault();
        $(this).fadeOut(100);
        const params = window.location.search;
        const nextUrl = $(this).attr('href');
        const newUrl = nextUrl + params;

        const $listingItems = $('.directory-listing__items-container');
        const $loadMore = $(this);

        const onSuccess = function (data) {
            const dataHtml = $.parseHTML(data);
            const $newListingItems = $(dataHtml).filter('.directory-listing__items-container').html();
            $($newListingItems).appendTo($listingItems);

            // $listingItems.append($newListingItems.html());
            const $newLoadMore = $(dataHtml).find('.js-paginate-load-more');
            if ($newLoadMore.length) {
                $loadMore.attr('href', $newLoadMore.attr('href'));
            } else {
                $loadMore.closest('.js-paginate-load-more-container').remove();
            }
            $loadMore.fadeIn(500);
            initLoginVenobox();
        };
        $.ajax({
            url: newUrl,
            type: 'get',
            success: onSuccess,
            error() {
                // console.log('Error' + err);
            },
        });
    });

    /* Accordion */
    $('.accordion .accordion__heading').click(function () {
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
            $(this).parent().find('.accordion__content-container').slideFadeToggle(200);
            $(this).parent().attr('aria-expanded', 'false');
        } else {
            $(this).parent().addClass('active');
            $(this).parent().find('.accordion__content-container').slideFadeToggle(200);
            $(this).parent().find('.accordion__content-container a').attr('tabindex', '0');
            $(this).parent().attr('aria-expanded', 'true');
        }
    });
    $('.accordion .accordion__content a').attr('tabindex', '-1');
    $('accordion .accordion__heading').keypress(function (e) {
        if (e.which === 13) {
            if ($(this).parent().hasClass('active')) {
                $(this).parent().removeClass('active');
                $(this).parent().find('.accordion__content-container').slideFadeToggle(200);
                $(this).parent().attr('aria-expanded', 'false');
            } else {
                $(this).parent().addClass('active');
                $(this).parent().find('.accordion__content-container').slideFadeToggle(200);
                $(this).parent().find('.accordion__content-container a').attr('tabindex', '0');
                $(this).parent().attr('aria-expanded', 'true');
            }
        }
    });

    /* JS Validated forms */
    $('body').on('submit', '.js-form', function () {
        let isFormValid = true;
        $('.form-errors').remove();
        $('.js-form-error').remove();
        function validateEmail(email) {
            const regex = /^([a-zA-Z0-9_.+-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email);
        }

        $(this).find('.js-required-field input').each(function () {
            if ($.trim($(this).val()).length === 0) {
                $(this).addClass('field-error');
                isFormValid = false;
            } else if ($(this).attr('type') === 'email') {
                const validEmail = validateEmail(($(this).val()));
                if (!validEmail) {
                    $(this).addClass('field-error');
                    isFormValid = false;
                    $(this).after('<div class="form-errors">Please enter a valid email address.</div>');
                } else {
                    $(this).removeClass('field-error');
                }
            } else {
                $(this).removeClass('field-error');
            }
        });
        $(this).find('.js-required-field textarea').each(function () {
            if ($.trim($(this).val()).length === 0) {
                $(this).addClass('field-error');
                isFormValid = false;
            } else {
                $(this).removeClass('field-error');
            }
        });
        if (!isFormValid) {
            const formError = `<div
                        class="js-form-error form-errors form-errors--block u-margin-top-small u-margin-bottom-small">
                        <p>Please fill in all required fields (indicated by *).</p></div>`;
            $(this).find('.form-group').first().before(formError);
        }
        return isFormValid;
    });
});



// WEBPACK FOOTER //
// ./assets/js/main.js